import { _login, _getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter, router } from '@/router'
const state = {
  token: getToken(),
  name: '',
  role: '',
  mychart: [],
  isFullScreen: false,
  dynamicHeight: '100%'
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLE: (state, role) => {
    state.role = role
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      _login({ username: username.trim(), password: password })
        .then((response) => {
          // eslint-disable-next-line
          const { access_token } = response
          commit('SET_TOKEN', access_token)
          setToken(access_token)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      _getInfo().then((response) => {
        const { username, role } = response

        if (!(username && role)) {
          reject(new Error('登录验证失败，请重新登录。'))
        }

        commit('SET_ROLE', role)
        commit('SET_NAME', username)
        resolve(response)
      })
      // .catch((error) => {
      //   // reject(error)
      // })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLE', '')
      removeToken()
      resetRouter()
      resolve()
      // 跳转到登录页面
      router.push('/login')
      // _logout(state.token)
      //   .then(() => {
      //     commit('SET_TOKEN', '')
      //     commit('SET_ROLE', '')
      //     removeToken()
      //     resetRouter()
      //     resolve()
      //   })
      //   .catch((error) => {
      //     reject(error)
      //   })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLE', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
